import React, {useEffect, useState} from "react";
import Api from "../../utils/api";
import {toast} from "react-toastify";
import ReactPaginate from "react-paginate";
import {useLocation} from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import {BarChart} from "@mui/icons-material";
import './style.css'
import {Tooltip} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import ButtonGroup from "@mui/material/ButtonGroup";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import queryString from 'query-string';

const Major = () => {


    useEffect(() => {
        getMajor()
    }, [])

    const location = useLocation();
    const query = queryString.parse(location.search);

    const [majorData, setMajorData] = useState(null)
    const [suppliers, setSuppliers] = useState(null)
    const [lastSupplierId, setLastSupplierId] = useState(null)
    const [lastProductId, setLastProductId] = useState(null)
    const [statusPriceModal, setStatusPriceModal] = useState(false)
    const [newPriceModal, setNewPriceModal] = useState(false)
    const [priceHistoryId, setPriceHistoryId] = useState(false)
    const [newPrice, setNewPrice] = useState(null)

    const [page, setPage] = useState(parseInt(query.page) || 1);


    const getMajor = () => {
        new Api().getTest('/backend/products/major').then((response) => {
            if (typeof response !== "undefined") {
                setMajorData(response);
            } else {
                toast.error('توی لود تامیین کننده مشکلی به وجود آمده');
            }
        })

        new Api().get('/products/supplier').then((response) => {
            if (typeof response !== "undefined") {
                if (!response.status) {
                    toast.error('توی لود تامیین کننده مشکلی به وجود آمده');
                } else {
                    setSuppliers(response.details);
                }
            } else {
                toast.error('توی لود تامیین کننده مشکلی به وجود آمده');
            }
        })
    }

    const editPrice = () => {
        let obj = {
            "form": "admin_major_price_history_update",
            "product_id": lastProductId,
            "supplier_id": lastSupplierId,
            "price_history_id": priceHistoryId,
            "price": newPrice
        }
        new Api().put('/products/major/update', obj).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    setMajorData(response.details);
                    setStatusPriceModal(false)
                } else {
                    console.log('no response', response);

                    toast.error(response.msg);
                }
            }
        })
    }

    const addPrice = () => {
        let obj = {
            "form": "major_price_history_create",
            "product_id": lastProductId,
            "supplier_id": lastSupplierId,
            "price": newPrice
        }
        new Api().postTest('/shop/major/add', obj).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    setMajorData(response?.details?.data);
                    setNewPriceModal(false)
                } else {
                    console.log('no response', response);

                    toast.error(response.msg);
                }
            }
        })
    }
    const pageCount = Math.ceil(parseInt(majorData.total) / parseInt(majorData?.per_page));

    return (
        <div className={"MuiContainer-root"}>
            <div style={{overflowX: 'auto'}}>
                <table className='table'>
                    <thead>
                    <tr>
                        <th>نام محصول</th>
                        {suppliers && suppliers?.map((supplier) => {
                            return (
                                <th>{supplier.name}({supplier.id})</th>
                            )
                        })}
                    </tr>
                    </thead>
                    <tbody>
                    {majorData?.data && majorData?.data.map((product) => {
                        return (
                            <tr>
                                <td>{product.title}</td>
                                {product?.suppliers_last_price.map((supplier) => {
                                    return (
                                        <td className={'td_box'}>
                                            <div className={'info_box'}>
                                                {
                                                    supplier?.history
                                                        ?
                                                        <>
                                                            <Tooltip title="ادیت" onClick={() => {
                                                                setLastSupplierId(supplier?.supplier?.id);
                                                                setLastProductId(product.id)
                                                                setPriceHistoryId(supplier?.history?.id)
                                                                setStatusPriceModal(true)
                                                            }}>
                                                                <IconButton>
                                                                    <EditIcon color="secondary"/>
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title="نمایش سابقه قیمت">
                                                                <IconButton>
                                                                    <BarChart color="action"/>
                                                                </IconButton>
                                                            </Tooltip>
                                                        </>
                                                        :

                                                        <Tooltip title="اضافه کردن قیمت" onClick={() => {
                                                            setLastSupplierId(supplier?.supplier?.id);
                                                            setLastProductId(product.id)
                                                            setNewPriceModal(true)
                                                        }}>
                                                            <IconButton>
                                                                <AddIcon color="secondary"/>
                                                            </IconButton>
                                                        </Tooltip>
                                                }
                                            </div>
                                            {supplier?.history?.price ?? '–'}
                                        </td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
            </div>
            <Modal
                disablePortal
                disableEnforceFocus
                disableAutoFocus
                open={statusPriceModal}
                onClose={() => {
                    setStatusPriceModal(false)
                }}
                aria-labelledby="server-modal-title"
                aria-describedby="server-modal-description"
                // container={() => rootRef.current}

            >
                <div className={"change_price"}>
                    <div className="form__group field">
                        <input
                            type="number"
                            className="form__field"
                            placeholder="Name"
                            name="newPrice"
                            id='newPrice'
                            required
                            onChange={(e) => {
                                setNewPrice(parseInt(e?.target?.value))
                            }}
                        />
                        <label htmlFor="newPrice" className="form__label">قیمت را وارد کنید</label>
                    </div>
                    <ButtonGroup color="primary" aria-label="outlined primary button group">
                        <Button variant="contained" color="primary" onClick={() => {
                            if (newPrice && Number.isInteger(newPrice)) {
                                editPrice()
                            } else {
                                toast.error('لطفا قیمت را به درستی وارد کنید.')
                            }
                        }}>
                            ذخیره
                        </Button>
                    </ButtonGroup>
                </div>
            </Modal>
            <Modal
                disablePortal
                disableEnforceFocus
                disableAutoFocus
                open={newPriceModal}
                onClose={() => {
                    setNewPriceModal(false)
                }}
                aria-labelledby="server-modal-title"
                aria-describedby="server-modal-description"
                // container={() => rootRef.current}

            >
                <div className={"change_price"}>
                    <div className="form__group field">
                        <input
                            type="number"
                            className="form__field"
                            placeholder="Name"
                            name="newPrice"
                            id='newPrice'
                            required
                            onChange={(e) => {
                                setNewPrice(parseInt(e?.target?.value))
                            }}
                        />
                        <label htmlFor="newPrice" className="form__label">قیمت را وارد کنید</label>
                    </div>
                    <ButtonGroup color="primary" aria-label="outlined primary button group">
                        <Button variant="contained" color="primary" onClick={() => {
                            if (newPrice && Number.isInteger(newPrice)) {
                                addPrice()
                            } else {
                                toast.error('لطفا قیمت را به درستی وارد کنید.')
                            }
                        }}>
                            ذخیره
                        </Button>
                    </ButtonGroup>
                </div>
            </Modal>
            <ReactPaginate
                previousLabel={'<'}
                nextLabel={'>'}
                breakLabel={'...'}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={(selectedItem) => setPage(selectedItem.selected + 1)}
                containerClassName={'pagination'}
                activeClassName={'active'}
            />
        </div>
    )
}

export default Major